export default __webpack_public_path__ + "static/media/giovanna.51e8832d.jpeg";